<template>
  <div class="booking-form">
    <div class="row">
      <div class="col-md-6">
        <h1 class="h2">Create Booking</h1>
        <div class="content-box mb-3">
          <div class="customer-details">
            <div class="mb-3">
              <label for="">Order Status</label>

              <select class="form-select" v-model="form.status" v-if="auth.user.agency.id === 1">
                <option :value="null"></option>
                <option value="draft" selected>Draft</option>
                <option value="request">Request</option>
                <option value="offer">Offer</option>
                <option value="reservation">Reservation</option>
                <option value="booked">Booked</option>
                <option value="cancelled">Cancelled</option>
              </select>
              <select class="form-select" v-model="form.status" v-else>
                <option value="request" selected>Request</option>
              </select>
            </div>
          </div>
        </div>
        <h3>Customer details</h3>
        <div class="content-box mb-3">
          <div class="customer-details">
            <div class="mb-3">
              <label for="">Select Customer</label>

              <select class="form-select" @change="getCustomer(this.value)" v-model="form.customers_id">
                <option :value="null"></option>
                <option v-for="customer in customers" :key="customer.id" :value="customer.id">
                  <span v-if="customer.company">{{ customer.company }} - </span>
                  {{ customer.last_name}}, {{ customer.first_name }} {{ customer.middle_name }}
                </option>
              </select>

              <CustomerData :customer="selectedCustomer" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <h2>Journey Schedule</h2>
        <div class="content-box mb-3">
          <div class="journeys">
            <JourneyCard class="" v-for="(journey, index) in form.journeys" :key="index" :form="form" :journey="journey" :types="types" :operators="operators" :airports="airports" :index="index" />
            <AddJourneyModal :form="form" :types="types" :operators="operators" :airports="airports" />
          </div>
        </div>

        <h3>Itinerary - Connection Flight Information</h3>
        <div class="content-box mb-3">
          <div class="itinerary">

            <div class="row">
              <div class="col-md-6">
                <h4>Inbound</h4>
                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Airline Name</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.inbound.airline">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Flight Number</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.inbound.flight_number">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Date</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.inbound.date">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Time</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.inbound.time">
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <h4>Outbound</h4>
                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Airline Name</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.outbound.airline">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Flight Number</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.outbound.flight_number">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Date</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.outbound.date">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Time</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.outbound.time">
                  </div>
                </div>
              </div>
            </div>

            <div class="form-check form-switch mt-3">
              <input class="form-check-input" type="checkbox" role="switch" id="show_on_booking" v-model="form.show_itinerary">
              <label class="form-check-label" for="show_on_booking">Show on Booking</label>
            </div>
          </div>
        </div>

        <h3>Order Comment</h3>
        <div class="content-box mb-3">
          <div class="itinerary">
            <editor
              api-key="wk0iduiwkjwjr9x9gm8yfkr7v8y5ltp7xab2qkdhgoupdzdd"
              v-model="form.comment"
              :init="{
                height: 300,
                menubar: false,
                toolbar:
                  'undo redo | bold italic'
              }"
            />

            <div class="form-check form-switch mt-3">
              <input class="form-check-input" type="checkbox" role="switch" id="show_comment" v-model="form.show_comment">
              <label class="form-check-label" for="show_comment">Show on Booking</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-box mb-3" v-if="selectedCustomer.id">
      <h3>Add passengers to booking</h3>
      <div class="passengers-list exists mb-3" v-if="customerPassengers.length">
        <div class="existing rounded">
          <p class="lead">Known passengers</p>
          <div class="add-passenger">
            <div class="btn btn-dark btn-sm btn-passenger" v-for="passenger in customerPassengers" :key="passenger.id" @click="existingPassenger(passenger)" :class="passengerClasses(passenger)">
              {{ passenger.given_names }} {{ passenger.surname }}
            </div>
          </div>
        </div>
      </div>
      <div class="passengers-list new">

        <div class="alert alert-info" v-if="!form.passengers.length">
          Please add passengers.
        </div>
        <div class="row">
          <div class="col-md-4" v-for="(passenger, index) in form.passengers" :key="index">
            <PassengerCard :form="form" :passenger="passenger" :passengers="customerPassengers" :customers="selectedCustomer" :index="index" />
          </div>
        </div>
      </div>

      <PassengerModal :passenger="[]" :form="form" :customer="selectedCustomer" />
    </div>

    <div class="content-box mb-3">
      <OrderTable :form="form" :order="order" :products="products" v-if="auth.user.agency.id === 1" />

      <div class="mb-3">
        <label for="" class="fw-bold">Internal Comment</label>
        <editor
          api-key="wk0iduiwkjwjr9x9gm8yfkr7v8y5ltp7xab2qkdhgoupdzdd"
          v-model="form.intern_comment"
          :init="{
            height: 300,
            menubar: false,
            toolbar:
              'undo redo | bold italic'
          }"
        />
      </div>

      <div class="mb-3" v-if="auth.user.agency.id === 1">
        <label for="" class="fw-bold">Payment URL</label>
        <input type="text" class="form-control" v-model="form.payment_url">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Editor from '@tinymce/tinymce-vue'
import LoadingButton from '@/Shared/LoadingButton'
import CustomerData from './CustomerData'
import PassengerModal from './PassengerModal'
import PassengerCard from './PassengerCard'
import EditPassengerModal from './EditPassengerModal'
import AddJourneyModal from './AddJourneyModal'
import JourneyCard from './JourneyCard.vue'
import OrderTable from './OrderTable'

export default {
  name: 'BookingForm',
  components: {
    Editor,
    LoadingButton,
    CustomerData,
    PassengerModal,
    PassengerCard,
    EditPassengerModal,
    AddJourneyModal,
    JourneyCard,
    OrderTable
  },
  props: {
    form: Object,
    auth: Object,
    bookings: Object,
    customers: Object,
    flights: Object,
    airports: Object,
    operators: Object,
    types: Object,
    products: Object
  },
  data() {
    return {
      selectedCustomer: [],
      customerPassengers: [],
    }
  },
  created() {
	  this.getCustomer();
  },
  methods: {
    passengerClasses(passenger) {
      return {
        active: this.form.passengers.some(pass => pass['id'] === passenger.id),
        expired: Date.parse(passenger.passport_expire) - Date.parse(new Date()) < 0
      }
    },
    async getCustomer() {
      let customerId = this.form.customers_id
      if (customerId) {
        const getCustomer = await axios.get(`/customers/${customerId}/get`)
        this.selectedCustomer = getCustomer.data[0];

        const getPassengers = await axios.get(`/passengers/${customerId}/get`)
        this.customerPassengers = getPassengers.data;
      }
    },
    existingPassenger(passenger) {
      const checkPassport = this.form.passengers.find(element => {
        if (element.id === passenger.id) {
          return true;
        }
      })
      if (!checkPassport) {
        this.form.passengers.push(passenger);
      }
    },
    removePassenger(index) {
      this.form.passengers.splice(index, 1);
    }
  }
}
</script>
